import React from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { routes } from 'utils/routing';

import NotFoundImage from './not-found-image';
import { Content, NotFoundContainer } from './styled';

const NotFound = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  return (
    <div data-testid="page-not-found">
      <Helmet title={formatMessage({ id: 'pageNotFound' })} />
      <NotFoundContainer>
        <NotFoundImage />
        <Content>
          <h1>{formatMessage({ id: 'whoops' })}</h1>
          <p>{formatMessage({ id: 'pageMoved' })}</p>
          <ActionButton onClick={() => navigate(routes.base)}>
            {formatMessage({ id: 'homepage' })}
          </ActionButton>
          <ActionButton variant={ActionButtonVariants.OUTLINE} onClick={() => navigate(0)}>
            {formatMessage({ id: 'refresh' })}
          </ActionButton>
        </Content>
      </NotFoundContainer>
    </div>
  );
};

export default NotFound;
